import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Button } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog, Paragraph, Card, Heading } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import Info from '@material-ui/icons/Info';
import ReplayIcon from '@material-ui/icons/Replay';
import FileUpload from '@material-ui/icons/SyncRounded';
import SyncDisabledRounded from '@material-ui/icons/SyncDisabledRounded';
import CategoryIcon from '@material-ui/icons/Category';
import Error from '@material-ui/icons/ReportProblem';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'react-toastify/dist/ReactToastify.css';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import qs from 'qs';
import * as moment from "moment-timezone";
import Login from '../common/login';
import exportFromJSON from 'export-from-json'
import { Link } from 'react-router-dom';

const cookies = new Cookies();

class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            loading: false,
            serch: false,
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            ordes2: [],
            // Pagination states
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            itemsPerPage: 10,
            hasNextPage: false,
            hasPreviousPage: false
        }
    }

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    textAlign: 'right',
                },
            },
            MuiTableCell: {
                root: {
                    textAlign: 'right',
                },
                head: {}
            },
        }
    })

    componentDidMount() {
        this.fetchPrintedOrders(1);
    }

    fetchPrintedOrders = (page) => {
        this.setState({ loading: true });
        var header = { "Content-Type": "application/json", token: cookies.get("token") };
        
        axios.get(host + `users/printed/orders/all?page=${page}&limit=${this.state.itemsPerPage}`, { headers: header })
            .then(res => {
                let arr = [];
                let items = res.data.data.printed;
                const pagination = res.data.data.pagination;

                for (let i = 0; i < items.length; i++) {
                    let obj = {
                        i: ((page - 1) * this.state.itemsPerPage) + i + 1,
                        name: <p> 
                            <Error style={items[i].hasChange == true ? { color: '#ffc107', cursor: 'pointer', } : { display: 'none' }} />
                            {items[i].name}
                        </p>,
                        id: items[i].id,
                        count: items[i].count,
                        createdAt: moment(items[i].createdAt).format('DD/MM/YYYY'),
                        items: <Link to={`/Dayle_items?id=${items[i].id}`}><CategoryIcon style={{ color: '#ffc107' }} /></Link>,
                        send: "",
                        info: <Link to={`/dayle_orders?id=${items[i].id}`}><Info /></Link>,
                        print: <a href={`https://pages.enfirad.com/Print2/${items[i].id}`}><ReplayIcon style={{ color: 'green' }} /></a>
                    };
                    
                    if (items[i].is_send == true) {
                        obj.send = <FileUpload style={{ color: '#28a745', cursor: 'pointer' }} />
                    } else {
                        obj.send =
                            <Component initialState={{ isShown: false }}>
                                {({ state, setState }) => (
                                    <Pane>
                                        <Dialog
                                            isShown={state.isShown}
                                            title="ارسال القائمة"
                                            intent="success"
                                            onCloseComplete={() => setState({ isShown: false })}
                                            confirmLabel="ارسال"
                                            cancelLabel="الغاء"
                                            onConfirm={() => {
                                                setState({ isShown: false })
                                                this.update_list(items[i].id)
                                            }}
                                        >
                                            <span id='msgDelete'> هل انت متأكد من ارسال القائمة رقم {items[i].id}</span>
                                        </Dialog>
                                        <SyncDisabledRounded 
                                            id={`sendBtn-${items[i].id}`} 
                                            style={{ color: '#0c71c1', cursor: 'pointer' }} 
                                            onClick={() => { setState({ isShown: true }) }} 
                                        />
                                    </Pane>
                                )}
                            </Component>
                    }
                    arr.push(obj);
                }

                this.setState({
                    orders: arr, 
                    loading: false,
                    spin: false,
                    currentPage: pagination.currentPage,
                    totalPages: pagination.totalPages,
                    totalItems: pagination.totalItems,
                    hasNextPage: pagination.hasNextPage,
                    hasPreviousPage: pagination.hasPreviousPage,
                    total_items: res.data.data.items_sum || 0,
                    total_orders: res.data.data.order_count || 0,
                    items_cost: res.data.data.items_cost || 0,
                    orders_cost: res.data.data.sells || 0,
                });
            })
            .catch(error => {
                console.log(error.response)
                this.setState({ loading: false });
                toast.error("حدث خطأ في تحميل البيانات", {
                    position: "top-center",
                    autoClose: 3000,
                });
            });
    }

    handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= this.state.totalPages) {
            this.fetchPrintedOrders(newPage);
        }
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value);
        this.setState({ itemsPerPage: newItemsPerPage }, () => {
            this.fetchPrintedOrders(1);
        });
    }

    handleChangeFrom = date => {
        this.setState({
            from: date
        });
    };

    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };

    update_list(id) {
        toast("انتظر قليلآ لحين الانتهاء من ارسال القائمة", {
            position: "top-center",
            autoClose: 20000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });

        document.getElementById(`sendBtn-${id}`).style.display = 'none'
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.post(host + `dashbord/list/send/${id}`, { headers: header })
            .then(response => {
                toast("تم ارسال القائمة بنجاح", {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
                this.fetchPrintedOrders(this.state.currentPage);
            })
            .catch(error => { 
                console.log(error)
                toast.error("حدث خطأ في ارسال القائمة", {
                    position: "top-center",
                    autoClose: 3000,
                });
            })
    }

    render() {
        if (cookies.get("token")) {
            const columns = [
                { field: "print", name: " اعادة طباعة", options: { width: 200, filter: false, sort: false, } },
                { field: "info", name: "قائمة طباعة", options: { width: 200, filter: false, sort: false, } },
                { field: "items", name: "المواد", options: { width: 200, filter: false, sort: false, } },
                { field: "send", name: " الارسال", options: { width: 200, filter: false, sort: false, } },
                { field: "createdAt", name: "التاريخ", options: { filter: false, sort: true, } },
                { field: "name", name: "اسم الناقل", options: { filter: true, sort: true, } },
                { field: "count", name: "عدد الطلبات", options: { filter: false, sort: true, } },
                { field: "id", name: "رقم القائمة", options: { width: 200, filter: true, sort: false, } },
            ];

            const options = {
                selectableRows: false,
                responsive: 'scroll',
                rowCursorHand: false,
                print: true,
                sort: false,
                pagination: false, // Disable built-in pagination
                rowsPerPage: this.state.itemsPerPage,
                filter: false,
                download: false,
                textLabels: {
                    body: {
                        noMatch: this.state.loading ? "جاري التحميل..." : "لم يتم العثور على سجلات مطابقة",
                        toolTip: "فرز",
                    },
                    pagination: {
                        next: "الصفحة التالية",
                        previous: "الصفحة السابقة",
                        rowsPerPage: "عدد الصفوف",
                        displayRows: "من",
                    },
                    toolbar: {
                        search: "بحث",
                        downloadCsv: "تنزيل",
                        print: "Print",
                        viewColumns: " التحكم بالاعمدة",
                        filterTable: "فلتر",
                    },
                    filter: {
                        all: "الكل",
                        title: "فلتر",
                        reset: "إعادة تعيين",
                    },
                    viewColumns: {
                        title: "عرض الأعمدة",
                        titleAria: "إظهار / إخفاء أعمدة الجدول",
                    },
                }
            }

            return (
                <Context.Consumer>
                    {ctx => {
                        return (
                            <div>
                                <div id='navDashContiner'></div>
                                <br />
                                
                                <div>
                                    <div className='DataTableContiner'>
                                        <MuiThemeProvider theme={this.getMuiTheme()}>
                                            <MaterialDatatable 
                                                data={this.state.orders} 
                                                columns={columns} 
                                                options={options} 
                                            />
                                        </MuiThemeProvider>
                                        
                                        {/* Custom Pagination Component */}
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '15px 25px',
                                            backgroundColor: '#ffffff',
                                            borderTop: '2px solid #e0e0e0',
                                            borderRadius: '0 0 8px 8px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                            direction: 'rtl'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    backgroundColor: '#f8f9fa',
                                                    padding: '8px 12px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #dee2e6'
                                                }}>
                                                    <span style={{ 
                                                        fontWeight: '500', 
                                                        color: '#495057',
                                                        fontSize: '14px'
                                                    }}>عدد الصفوف:</span>
                                                    <select 
                                                        value={this.state.itemsPerPage}
                                                        onChange={this.handleItemsPerPageChange}
                                                        style={{
                                                            padding: '6px 10px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #ced4da',
                                                            backgroundColor: '#fff',
                                                            fontSize: '14px',
                                                            fontWeight: '500',
                                                            color: '#495057',
                                                            cursor: 'pointer',
                                                            outline: 'none',
                                                            transition: 'border-color 0.2s'
                                                        }}
                                                        onFocus={(e) => e.target.style.borderColor = '#4CAF50'}
                                                        onBlur={(e) => e.target.style.borderColor = '#ced4da'}
                                                    >
                                                        <option value="10">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                    </select>
                                                </div>
                                                
                                                <div style={{
                                                    backgroundColor: '#e8f5e9',
                                                    padding: '8px 16px',
                                                    borderRadius: '20px',
                                                    border: '1px solid #4CAF50'
                                                }}>
                                                    <span style={{
                                                        color: '#2e7d32',
                                                        fontSize: '13px',
                                                        fontWeight: '600'
                                                    }}>
                                                        عرض {((this.state.currentPage - 1) * this.state.itemsPerPage) + 1} - {Math.min(this.state.currentPage * this.state.itemsPerPage, this.state.totalItems)} من إجمالي {this.state.totalItems} سجل
                                                    </span>
                                                </div>
                                            </div>

                                            <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: '8px',
                                                backgroundColor: '#f8f9fa',
                                                padding: '6px',
                                                borderRadius: '8px'
                                            }}>
                                                <button
                                                    onClick={() => this.handlePageChange(1)}
                                                    disabled={!this.state.hasPreviousPage || this.state.loading}
                                                    title="الصفحة الأولى"
                                                    style={{
                                                        padding: '8px 12px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        backgroundColor: this.state.hasPreviousPage && !this.state.loading ? '#fff' : '#f8f9fa',
                                                        cursor: this.state.hasPreviousPage && !this.state.loading ? 'pointer' : 'not-allowed',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        boxShadow: this.state.hasPreviousPage && !this.state.loading ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                                                        transition: 'all 0.2s',
                                                        opacity: this.state.hasPreviousPage && !this.state.loading ? 1 : 0.4
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (this.state.hasPreviousPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#4CAF50';
                                                            e.target.style.color = '#fff';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (this.state.hasPreviousPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#fff';
                                                            e.target.style.color = 'inherit';
                                                        }
                                                    }}
                                                >
                                                    <FirstPage style={{ fontSize: '20px' }} />
                                                </button>

                                                <button
                                                    onClick={() => this.handlePageChange(this.state.currentPage - 1)}
                                                    disabled={!this.state.hasPreviousPage || this.state.loading}
                                                    title="الصفحة السابقة"
                                                    style={{
                                                        padding: '8px 12px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        backgroundColor: this.state.hasPreviousPage && !this.state.loading ? '#fff' : '#f8f9fa',
                                                        cursor: this.state.hasPreviousPage && !this.state.loading ? 'pointer' : 'not-allowed',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        boxShadow: this.state.hasPreviousPage && !this.state.loading ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                                                        transition: 'all 0.2s',
                                                        opacity: this.state.hasPreviousPage && !this.state.loading ? 1 : 0.4
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (this.state.hasPreviousPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#4CAF50';
                                                            e.target.style.color = '#fff';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (this.state.hasPreviousPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#fff';
                                                            e.target.style.color = 'inherit';
                                                        }
                                                    }}
                                                >
                                                    <ChevronRight style={{ fontSize: '20px' }} />
                                                </button>

                                                <div style={{ 
                                                    padding: '8px 20px',
                                                    backgroundColor: '#4CAF50',
                                                    color: '#fff',
                                                    borderRadius: '20px',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    minWidth: '120px',
                                                    textAlign: 'center',
                                                    boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)'
                                                }}>
                                                    الصفحة {this.state.currentPage} من {this.state.totalPages}
                                                </div>

                                                <button
                                                    onClick={() => this.handlePageChange(this.state.currentPage + 1)}
                                                    disabled={!this.state.hasNextPage || this.state.loading}
                                                    title="الصفحة التالية"
                                                    style={{
                                                        padding: '8px 12px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        backgroundColor: this.state.hasNextPage && !this.state.loading ? '#fff' : '#f8f9fa',
                                                        cursor: this.state.hasNextPage && !this.state.loading ? 'pointer' : 'not-allowed',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        boxShadow: this.state.hasNextPage && !this.state.loading ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                                                        transition: 'all 0.2s',
                                                        opacity: this.state.hasNextPage && !this.state.loading ? 1 : 0.4
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (this.state.hasNextPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#4CAF50';
                                                            e.target.style.color = '#fff';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (this.state.hasNextPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#fff';
                                                            e.target.style.color = 'inherit';
                                                        }
                                                    }}
                                                >
                                                    <ChevronLeft style={{ fontSize: '20px' }} />
                                                </button>

                                                <button
                                                    onClick={() => this.handlePageChange(this.state.totalPages)}
                                                    disabled={!this.state.hasNextPage || this.state.loading}
                                                    title="الصفحة الأخيرة"
                                                    style={{
                                                        padding: '8px 12px',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        backgroundColor: this.state.hasNextPage && !this.state.loading ? '#fff' : '#f8f9fa',
                                                        cursor: this.state.hasNextPage && !this.state.loading ? 'pointer' : 'not-allowed',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        boxShadow: this.state.hasNextPage && !this.state.loading ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                                                        transition: 'all 0.2s',
                                                        opacity: this.state.hasNextPage && !this.state.loading ? 1 : 0.4
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (this.state.hasNextPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#4CAF50';
                                                            e.target.style.color = '#fff';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (this.state.hasNextPage && !this.state.loading) {
                                                            e.target.style.backgroundColor = '#fff';
                                                            e.target.style.color = 'inherit';
                                                        }
                                                    }}
                                                >
                                                    <LastPage style={{ fontSize: '20px' }} />
                                                </button>
                                            </div>
                                        </div>

                                        {this.state.loading && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                zIndex: 1000
                                            }}>
                                                <CircularProgress />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                    }}
                </Context.Consumer>
            )
        }
        else {
            return <Login />
        }
    }
}

export default Selles_Reports;